<template>
    <b-overlay :show="tableLoading" rounded="sm">

        <b-card class="inner-block health-listing">
            <b-card-header>

                <b-row class="mt-2">


                    <b-col cols="12" v-if="entityIdx === 1"
                        class="d-flex align-items-start flex-column flex-md-row gap-3">
                        <!-- <div class="text-start">
                <strong>{{ filters.selectedYear }} Activity Target:</strong><br />
                <span class="fs-6">{{ calculateTotals().total_activity_target }} Activities</span>
              </div>
              <div class="text-start">
                <strong>{{ filters.selectedYear }} Value Target:</strong><br />
                <span class="fs-6">${{ calculateTotals().total_value_target }}</span>
               
              </div> -->

                        <b-form-select v-custom-validation="$selectRequired()" value-field="id" text-field="name"
                            id="input-activity_type" v-model="filters.activity_type" :options="orderTypesArray"
                            class="w-auto">
                            <template #first>
                                <b-form-select-option :value="null" selected>
                                    {{ $translate('select_activity_type') }}
                                </b-form-select-option>
                            </template>
                        </b-form-select>
                       
                        <b-form-select v-custom-validation="$selectRequired()" value-field="value" text-field="month"
                            id="input-month" v-model="filters.selectedMonth" required :options="monthOptions"
                            class="w-auto">
                            <template #first>
                                <b-form-select-option :value="null" selected>
                                    {{ $translate('select_month') }}
                                </b-form-select-option>
                            </template>
                        </b-form-select>
                        <b-form-select v-custom-validation="$selectRequired()" value-field="year" text-field="year"
                            id="input-year" v-model="filters.selectedYear" required :options="yearOptions"
                            class="w-auto">
                            <template #first>
                                <b-form-select-option :value="null" selected>
                                    {{ $translate('select_year') }}
                                </b-form-select-option>
                            </template>
                        </b-form-select>
                        <!--   
              <b-form-select v-custom-validation="$selectRequired()" value-field="year" text-field="year" id="input-year"
                v-model="filters.selectedYear" required :options="yearOptions" class="w-auto">
                <template #first>
                  <b-form-select-option :value="null" selected>
                    {{ $translate('select_year') }}
                  </b-form-select-option>
                </template>
              </b-form-select>
   -->
                        <!-- <b-button id="export-checkoff-item-btn" variant="blue-icon" v-b-tooltip.hover
                            :title="$translate('export')" @click="export_roster()" v-if="hasPermissionCreate">
                            <img src="@/assets/images/icon/export.svg" />
                        </b-button> -->

                        <b-button variant="blue-icon" id="calender-view-btn" v-if="hasPermissionView" class="me-2"
                            v-b-tooltip.hover :title="$translate('list_view')" @click="list_view()">
                            <img src="@/assets/images/icon/activities.svg" />
                        </b-button>
                    </b-col>
                    <b-col cols="12" v-if="entityIdx === 2" class="d-flex flex-column">


                        <!-- Filter Dropdowns in the next line -->
                        <div class="d-flex flex-wrap gap-3">
                            <b-form-select v-model="officer_filters.selectedRole" :options="roles" name="radios-stacked"
                                text-field="name" value-field="id" class="w-auto">
                                <template #first>
                                    <b-form-select-option :value="null" selected>{{ $translate('select_role')
                                        }}</b-form-select-option>
                                </template>
                            </b-form-select>

                            <b-form-select v-custom-validation="$selectRequired()" value-field="id" text-field="name"
                                id="input-officers" v-model="officer_filters.selectedOfficer" required
                                :options="officers" class="w-auto">
                                <template #first>
                                    <b-form-select-option :value="null" selected>
                                        {{ $translate('select_officer') }}
                                    </b-form-select-option>
                                </template>
                            </b-form-select>

                            <!-- <b-form-select v-custom-validation="$selectRequired()" value-field="name" text-field="name"
                                id="input-targets" v-model="officer_filters.selectedTarget" required :options="targets"
                                class="w-auto">
                                <template #first>
                                    <b-form-select-option :value="null" selected>
                                        {{ $translate('select_targets') }}
                                    </b-form-select-option>
                                </template>
                            </b-form-select> -->
                            <!-- Month Dropdown -->
                            <b-form-select v-custom-validation="$selectRequired()" value-field="value"
                                text-field="month" id="input-month" v-model="officer_filters.selectedMonth" required
                                :options="monthOptions" class="w-auto">
                                <template #first>
                                    <b-form-select-option :value="null" selected>
                                        {{ $translate('select_month') }} <!-- Adjust translation as necessary -->
                                    </b-form-select-option>
                                </template>
                            </b-form-select>
                            <b-form-select v-custom-validation="$selectRequired()" value-field="year" text-field="year"
                                id="input-year" v-model="officer_filters.selectedYear" required :options="yearOptions"
                                class="w-auto">
                                <template #first>
                                    <b-form-select-option :value="null" selected>
                                        {{ $translate('select_year') }}
                                    </b-form-select-option>
                                </template>
                            </b-form-select>
                            <!-- <b-button id="export-checkoff-item-btn" variant="blue-icon" v-b-tooltip.hover
                                :title="$translate('export')" @click="export_roster()" v-if="hasPermissionCreate"
                                class="me-2">
                                <img src="@/assets/images/icon/export.svg" />
                            </b-button> -->

                            <b-button variant="blue-icon" id="calender-view-btn" v-if="hasPermissionView" class="me-2"
                                v-b-tooltip.hover :title="$translate('list_view')" @click="list_view()">
                                <img src="@/assets/images/icon/activities.svg" />
                            </b-button>
                        </div>
                    </b-col>

                </b-row>

            </b-card-header>
            <b-card-body class="button-off">

                <div id="navbar-animmenu">
                    <ul class="show-dropdown main-navbar">
                        <div class="hori-selector" ref="selector" :style="{ width: divWidth, left: divLeft }">
                            <div class="left"></div>
                            <div class="right"></div>
                        </div>
                        <li v-for="item in entityOptions" :key="'entity' + item.value"
                            :class="{ active: entityIdx === item.value }" @click="changeEntityIdx(item.value)">
                            <a href="javascript:void(0);" :id="item.text">
                                <i :class="getIcons[item.value]" aria-hidden="true"></i>
                                {{ item.text }}
                            </a>
                        </li>
                    </ul>

                    <!-- Display different content based on selected tab -->

                </div>
                <div v-if="entityIdx === 1" class="content" style="padding-top:100px;">
                    <b-row>
                        <b-col cols="12" class="mb-4 d-flex justify-content-between align-items-center">
                            <p class="mb-0">
                                <strong>{{ $translate('activity_target') }} :</strong>
                                <br>
                                {{ target_progress?.total_target_activity }}
                            </p>
                            <p class="mb-0">
                                <strong>{{ $translate('activity_target_achieved') }} :</strong>
                                <br>
                                {{ target_progress.total_completed_activity }}
                            </p>
                            <p class="mb-0">
                                <strong>{{ $translate('value_target') }} :</strong>
                                <br>
                                <span v-if="value_progress.total_target_value > 0">{{
                                    formatCurrency(value_progress.total_target_value) }}</span>
                                <span v-else>$ 0.00</span>
                            </p>
                            <p class="mb-0">
                                <strong>{{ $translate('value_target_achieved') }} :</strong>
                                <br>
                                <span v-if="value_progress.total_completed_amount > 0">{{
                                    formatCurrency(value_progress.total_completed_amount) }}</span>
                                <span v-else>$ 0.00</span>
                            </p>
                        </b-col>


                    </b-row>
                    <b-row>
                        <b-col cols="12" md="6" class="mb-4">
                            <b-card class="text-left square-card">
                                <template #header>
                                    <div class="d-flex justify-content-between align-items-center">
                                        <h3 class="mb-0">{{ $translate('target_progress') }}</h3>
                                        <b-form-select v-custom-validation="$selectRequired()" value-field="name"
                                            text-field="name" id="input-targets"
                                            v-model="target_progress_filter.selectedTarget" required :options="targets"
                                            class="w-auto ml-3">
                                            <template #first>
                                                <b-form-select-option :value="null" selected>
                                                    {{ $translate('select_targets') }}
                                                </b-form-select-option>
                                            </template>
                                        </b-form-select>
                                    </div>
                                </template>


                                <b-card-body>
                                    <div class="flex-grow-1 me-2">
                                        <b-progress class="custom-progress" :max="100" show-value>
                                            <b-progress-bar
                                                :value="(target_progress.total_completed_activity * 100) / target_progress?.total_target_activity"
                                                style="background-color: #c1f1fd;">
                                                <span style="font-size: 0.8em; font-weight: bold;color:#000000;">
                                                    {{ ((target_progress.total_completed_activity
                                                        * 100) / target_progress?.total_target_activity).toFixed(2) }} %
                                                </span>
                                            </b-progress-bar>
                                            <b-progress-bar
                                                :value="(target_progress?.total_target_activity - target_progress.total_completed_activity) * 100 / target_progress?.total_target_activity"
                                                style="background-color: #fb7289;">
                                                <span style="font-size: 0.8em; font-weight: bold;">
                                                    {{ ((target_progress?.total_target_activity -
                                                        target_progress.total_completed_activity
                                                    ) * 100 / target_progress?.total_target_activity).toFixed(2) }} %
                                                </span>
                                            </b-progress-bar>
                                        </b-progress>
                                    </div>

                                    <b-card class="square-card mt-3">
                                        <div style="max-height: 300px; overflow-y: auto;">
                                        <div v-for="(progress, index) in target_progress?.officers" :key="index"
                                            class="mb-4">

                                            <p>{{ progress.officer.first_name }} {{ progress.officer.last_name }} ({{
                                                progress.completed_activities
                                            }} / {{ progress.total_assigned_activity }})</p>
                                            <b-progress class="custom-progress-inside" :max="100" show-value>
                                                <b-progress-bar
                                                    :value="(progress.completed_activities * 100) / progress.total_assigned_activity"
                                                    style="background-color: #c1f1fd;">
                                                    <span style="font-size: 0.8em; font-weight: bold;color:#000000;">
                                                        {{ ((progress.completed_activities * 100) /
                                                            progress.total_assigned_activity).toFixed(2) }} %
                                                    </span>
                                                </b-progress-bar>
                                                <b-progress-bar
                                                    :value="((progress.total_assigned_activity - progress.completed_activities) * 100) / progress.total_assigned_activity"
                                                    style="background-color: #fb7289;">
                                                    <span style="font-size: 0.8em; font-weight: bold;">
                                                        {{ (((progress.total_assigned_activity -
                                                            progress.completed_activities) * 100) /
                                                            progress.total_assigned_activity).toFixed(2) }} %
                                                    </span>
                                                </b-progress-bar>
                                            </b-progress>
                                        </div>
                                    </div>


                                    </b-card>
                                </b-card-body>
                            </b-card>

                        </b-col>
                        <b-col cols="12" md="6" class="mb-4">
                            <b-card class="text-left square-card">
                                <template #header>
                                    <div class="d-flex justify-content-between align-items-center">
                                        <h3 class="mb-0">{{ $translate('value_progress') }}</h3>
                                        <b-form-select v-custom-validation="$selectRequired()" value-field="name"
                                            text-field="name" id="input-targets"
                                            v-model="value_progress_filter.selectedTarget" required :options="targets"
                                            class="w-auto ml-3">
                                            <template #first>
                                                <b-form-select-option :value="null" selected>
                                                    {{ $translate('select_targets') }}
                                                </b-form-select-option>
                                            </template>
                                        </b-form-select>
                                    </div>
                                </template>


                                <b-card-body>
                                    <div class="flex-grow-1 me-2">
                                        <!-- <b-progress class="custom-progress" :max="100" show-value>
                                          <b-progress-bar
                                            :value="value_progress.total_target_value > 0 ? (value_progress.total_completed_amount * 100) / value_progress.total_target_value : 0"
                                            style="background-color: #c1f1fd;">
                                            <span style="font-size: 0.8em; font-weight: bold;color:#000000;">
                                              {{ value_progress.total_target_value > 0 ? ((value_progress.total_completed_amount * 100) / value_progress.total_target_value).toFixed(2) : 0 }} %
                                            </span>
                                          </b-progress-bar>
                                          <b-progress-bar
                                            :value="value_progress.total_target_value > 0 ? ((value_progress.total_target_value - value_progress.total_completed_amount) * 100) / value_progress.total_target_value : 0"
                                            style="background-color: #fb7289;">
                                            <span style="font-size: 0.8em; font-weight: bold;">
                                              {{ value_progress.total_target_value > 0 ? (((value_progress.total_target_value - value_progress.total_completed_amount) * 100) / value_progress.total_target_value).toFixed(2) : 0 }} %
                                            </span>
                                          </b-progress-bar>
                                        </b-progress> -->
                                        <!-- <doughnut-chart   :data="value_progress_chart"/> -->

                                        <half-circle-chart v-if="load_chart"
                                            :value_progress="value_progress_chart"></half-circle-chart>

                                    </div>

                                    <b-card class="square-card mt-3">
                                        <div style="max-height: 300px; overflow-y: auto;">
                                        <div v-for="(progress, index) in value_progress?.officers" :key="index"
                                            class="mb-4">

                                            <p>{{ progress.officer.first_name }} {{ progress.officer.last_name }} ( $ {{
                                                progress.total_completed_amount
                                            }} / $ {{ progress.total_target_amount }})</p>
                                            <b-progress class="custom-progress-inside" :max="100" show-value>
                                                <b-progress-bar
                                                    :value="(progress.total_completed_amount * 100) / progress.total_target_amount"
                                                    style="background-color: #c1f1fd;">
                                                    <span style="font-size: 0.8em; font-weight: bold;color:#000000;">
                                                        {{ ((progress.total_completed_amount * 100) /
                                                            progress.total_target_amount).toFixed(2) }} %
                                                    </span>
                                                </b-progress-bar>
                                                <b-progress-bar
                                                    :value="((progress.total_target_amount - progress.total_completed_amount) * 100) / progress.total_target_amount"
                                                    style="background-color: #fb7289;">
                                                    <span style="font-size: 0.8em; font-weight: bold;">
                                                        {{ (((progress.total_target_amount -
                                                            progress.total_completed_amount) * 100) /
                                                            progress.total_target_amount).toFixed(2) }} %
                                                    </span>
                                                </b-progress-bar>
                                            </b-progress>
                                        </div>
                                    </div>


                                    </b-card>
                                </b-card-body>
                            </b-card>

                        </b-col>

                        <b-col cols="12" md="12" class="mb-4">
                            <b-card class="text-left square-card">
                                <template #header>
                                    <div class="d-flex justify-content-between align-items-center">
                                        <h3 class="mb-0">{{ $translate('activity_count_breakdown') }}</h3>

                                    </div>
                                </template>


                                <b-card-body>
                                    <div class="flex-grow-1 me-2">

                                        <ActivityChart v-if="load_activity" :activities="activities" />

                                    </div>


                                </b-card-body>
                            </b-card>

                        </b-col>

                        <!-- <b-col cols="12" md="6" class="mb-4">
                            <b-card class="text-center square-card">
                                <p>Card Content 4</p>
                            </b-card>
                        </b-col> -->
                    </b-row>

                </div>

                <div v-if="entityIdx === 2" class="content" style="padding-top:100px;">
                    <b-row>
                        <b-col cols="12" class="mb-4 d-flex justify-content-between align-items-center">
                            <p class="mb-0">
                                <strong>{{ $translate('activity_target') }} :</strong>
                                <br>
                                {{ target_progress_officer?.total_target_activity }}
                            </p>
                            <p class="mb-0">
                                <strong>{{ $translate('activity_target_achieved') }} :</strong>
                                <br>
                                {{ target_progress_officer.total_completed_activity }}
                            </p>
                            <p class="mb-0">
                                <strong>{{ $translate('value_target') }} :</strong>
                                <br>
                                <span v-if="value_progress_officer.total_target_value > 0">{{
                                    formatCurrency(value_progress_officer.total_target_value) }}</span>
                                <span v-else>$ 0.00</span>
                            </p>
                            <p class="mb-0">
                                <strong>{{ $translate('value_target_achieved') }} :</strong>
                                <br>
                                <span v-if="value_progress_officer.total_completed_amount > 0">{{
                                    formatCurrency(value_progress_officer.total_completed_amount) }}</span>
                                <span v-else>$ 0.00</span>
                            </p>
                        </b-col>


                    </b-row>
                    <b-row>
                        <b-col cols="12" md="6" class="mb-4">
                            <b-card class="text-left square-card">
                                <template #header>
                                    <div class="d-flex justify-content-between align-items-center">
                                        <h3 class="mb-0">{{ $translate('target_progress') }}</h3>
                                        <b-form-select v-custom-validation="$selectRequired()" value-field="name"
                                            text-field="name" id="input-targets"
                                            v-model="target_progress_filter_officer.selectedTarget" required :options="targets"
                                            class="w-auto ml-3">
                                            <template #first>
                                                <b-form-select-option :value="null" selected>
                                                    {{ $translate('select_targets') }}
                                                </b-form-select-option>
                                            </template>
                                        </b-form-select>
                                    </div>
                                </template>


                                <b-card-body v-if="target_progress_officer?.total_target_activity">
                                    <div class="flex-grow-1 me-2">

                                        <b-progress class="custom-progress" :max="100" show-value>
                                            <b-progress-bar
                                                :value="(target_progress_officer.total_completed_activity * 100) / target_progress_officer?.total_target_activity"
                                                style="background-color: #c1f1fd;">
                                                <span style="font-size: 0.8em; font-weight: bold;color:#000000;">
                                                    {{ ((target_progress_officer.total_completed_activity
                                                        * 100) / target_progress_officer?.total_target_activity).toFixed(2)
                                                    }} %
                                                </span>
                                            </b-progress-bar>
                                            <b-progress-bar
                                                :value="(target_progress_officer?.total_target_activity - target_progress_officer.total_completed_activity) * 100 / target_progress_officer?.total_target_activity"
                                                style="background-color: #fb7289;">
                                                <span style="font-size: 0.8em; font-weight: bold;">
                                                    {{ ((target_progress_officer?.total_target_activity -
                                                        target_progress_officer.total_completed_activity
                                                    ) * 100 / target_progress_officer?.total_target_activity).toFixed(2)
                                                    }} %
                                                </span>
                                            </b-progress-bar>
                                        </b-progress>
                                    </div>

                                    <b-card class="square-card mt-3">
                                        <div style="max-height: 300px; overflow-y: auto;">
                                            <div v-for="(progress, index) in target_progress_officer?.officers"
                                                :key="index" class="mb-4">
                                                <p>{{ progress.officer.name }} ({{ progress.completed_activities }} / {{
                                                    progress.total_assigned_activity }})</p>

                                                <b-progress class="custom-progress-inside" :max="100" show-value>
                                                    <b-progress-bar
                                                        :value="(progress.completed_activities * 100) / progress.total_assigned_activity"
                                                        style="background-color: #c1f1fd;">
                                                        <span
                                                            style="font-size: 0.8em; font-weight: bold;color:#000000;">
                                                            {{ ((progress.completed_activities * 100) /
                                                                progress.total_assigned_activity).toFixed(2)
                                                            }} %
                                                        </span>
                                                    </b-progress-bar>

                                                    <b-progress-bar
                                                        :value="((progress.total_assigned_activity - progress.completed_activities) * 100) / progress.total_assigned_activity"
                                                        style="background-color: #fb7289;">
                                                        <span style="font-size: 0.8em; font-weight: bold;">
                                                            {{ (((progress.total_assigned_activity -
                                                                progress.completed_activities) * 100) /
                                                                progress.total_assigned_activity).toFixed(2) }} %
                                                        </span>
                                                    </b-progress-bar>
                                                </b-progress>
                                            </div>
                                        </div>



                                    </b-card>
                                </b-card-body>
                            </b-card>

                        </b-col>
                        <b-col cols="12" md="6" class="mb-4">
                            <b-card class="text-left square-card">
                                <template #header>
                                    <div class="d-flex justify-content-between align-items-center">
                                        <h3 class="mb-0">{{ $translate('value_progress') }}</h3>
                                        <b-form-select v-custom-validation="$selectRequired()" value-field="name"
                                            text-field="name" id="input-targets"
                                            v-model="value_progress_filter_officer.selectedTarget" required :options="targets"
                                            class="w-auto ml-3">
                                            <template #first>
                                                <b-form-select-option :value="null" selected>
                                                    {{ $translate('select_targets') }}
                                                </b-form-select-option>
                                            </template>
                                        </b-form-select>
                                    </div>
                                </template>


                                <b-card-body>
                                    <div class="flex-grow-1 me-2">
                                        <!-- <half-circle-chart v-if="load_chart_officer"
                                        :value_progress="value_progress_chart_officer"></half-circle-chart> -->
                                        <half-circle-chart-officer 
                                        v-if="load_chart_officer"
                                        :value_progress="value_progress_chart_officer"
                                    ></half-circle-chart-officer>

                                    </div>

                                    <b-card class="square-card mt-3">
                                        <div style="max-height: 300px; overflow-y: auto;">
                                        <div v-for="(progress, index) in value_progress_officer?.officers" :key="index"
                                            class="mb-4">

                                            <p>{{ progress.officer.first_name }} {{ progress.officer.last_name }} ( $ {{
                                                progress.total_completed_amount
                                            }} / $ {{ progress.total_target_amount }})</p>
                                            <b-progress class="custom-progress-inside" :max="100" show-value>
                                                <b-progress-bar
                                                    :value="(progress.total_completed_amount * 100) / progress.total_target_amount"
                                                    style="background-color: #c1f1fd;">
                                                    <span style="font-size: 0.8em; font-weight: bold;color:#000000;">
                                                        {{ ((progress.total_completed_amount * 100) /
                                                            progress.total_target_amount).toFixed(2) }} %
                                                    </span>
                                                </b-progress-bar>
                                                <b-progress-bar
                                                    :value="((progress.total_target_amount - progress.total_completed_amount) * 100) / progress.total_target_amount"
                                                    style="background-color: #fb7289;">
                                                    <span style="font-size: 0.8em; font-weight: bold;">
                                                        {{ (((progress.total_target_amount -
                                                            progress.total_completed_amount) * 100) /
                                                            progress.total_target_amount).toFixed(2) }} %
                                                    </span>
                                                </b-progress-bar>
                                            </b-progress>
                                        </div>
                                    </div>

                                    </b-card>
                                </b-card-body>
                            </b-card>

                        </b-col>


                    </b-row>
                </div>
            </b-card-body>
        </b-card>
    </b-overlay>
</template>
<script>
import _ from 'lodash'

import popupMixins from '@/mixins/popupMixins'
import permissionsMixins from '@/mixins/permissionsMixins'
import TargetsFilters from './TargetsFilters.vue'
import importMixins from "@/mixins/importMixins";
import ImportForm from "@/components/ImportForm.vue";
import PageActions from "@/components/PageActions.vue";

import dropdownIcon2 from "@/assets/images/icon/i-2.svg";

import dropdownIcon7 from "@/assets/images/icon/i-7.svg";

import HalfCircleChart from './HalfCircleChart.vue';
import HalfCircleChartOfficer from './HalfCircleChartOfficer.vue';
import ActivityChart from './ActivityChart.vue';

const inventoryFields = [
    { name: "name", label: "name", required: true, type: "text" },
    { name: "month_year", label: "month_year", required: true, type: "text" },

    {
        name: "activity_type",
        label: "activity_type",
        required: true,
        type: "text",
    },
    { name: "target_type", label: "target_type", required: true, type: "text" },

    {
        name: "target_no_of_activity",
        label: "target_no_of_activity",
        required: false,
        type: "number",
    },
    {
        name: "target_total_value",
        label: "target_total_value",
        required: false,
        type: "number",
    },
    {
        name: "role",
        label: "role",
        required: false,
        type: "text",
    },
    {
        name: "officer",
        label: "officer",
        required: false,
        type: "text",
    },
    {
        name: "agent",
        label: "agent",
        required: false,
        type: "text",
    },
    {
        name: "customer_segment",
        label: "customer_segment",
        required: false,
        type: "text",
    },
    {
        name: "customer_group",
        label: "customer_group",
        required: false,
        type: "text",
    },
    {
        name: "interaction_type",
        label: "interaction_type",
        required: false,
        type: "text",
    },




];
export default {
    name: 'health-table',
    mixins: [popupMixins, permissionsMixins, importMixins],
    components: {
        TargetsFilters,
        ImportForm,
        PageActions,
        HalfCircleChart,
        ActivityChart,
        HalfCircleChartOfficer

    },
    props: {
        type: {
            type: String,
        },
        title: String,
    },
    data() {
        return {
            selectedOrders: [],
            query: '',
            tableLoading: false,
            toggle_filters: false,
            filters: {
                selectedYear: new Date().getFullYear(),
                activity_type: null,
                selectedMonth : null,
            },
            target_progress_filter: {
                selectedTarget: null,
            },
            value_progress_filter: {
                selectedTarget: null,
            },
            target_progress_filter_officer: {
                selectedTarget: null,
            },
            value_progress_filter_officer: {
                selectedTarget: null,
            },
            officer_filters: {
                selectedYear: new Date().getFullYear(),
                selectedRole: null,
                selectedOfficer: null,
                selectedTarget: null,
                selectedMonth : null,
            },
            importModal: false,
            inventoryFields,
            isTarget: 'yes',
            activityTypes: [],
            isModalVisible: false,
            entityIdx: 1, // Default to "Company" tab
            divWidth: "160px", // Placeholder for selector width
            divLeft: "0px", // Placeholder for selector position
            entityOptions: [
                { value: 1, text: "Company" },
                { value: 2, text: "Officer" },
            ],
            yearOptions: this.generateYearOptions(),
            monthName: 'October', // Change it dynamically based on the data
            activitiesCount: 89,  // Total number of activities
            doneActivities: 70,   // Number of completed activities
            value: 45,
            max: 100,
            year_data: [],
            year_data_officer: [],
            target_progress: [],
            value_progress: [],
            target_progress_officer: [],
            value_progress_officer: [],
            load_chart: false,
            load_activity: false,
            load_chart_officer : false,
            value_progress_chart: {
                total_completed_amount: 0,
                total_target_value: 0, 
                total_completed_amount_officer: 0, 
                total_target_value_officer: 0 
            },
            value_progress_chart_officer : {
                total_completed_amount: 0, 
                total_target_value: 0, 
                total_completed_amount_officer: 0, 
                total_target_value_officer: 0 
            },
            activities: {

            },
            monthOptions: [
                { month: 'January', value: 1 },
                { month: 'February', value: 2 },
                { month: 'March', value: 3 },
                { month: 'April', value: 4 },
                { month: 'May', value: 5 },
                { month: 'June', value: 6 },
                { month: 'July', value: 7 },
                { month: 'August', value: 8 },
                { month: 'September', value: 9 },
                { month: 'October', value: 10 },
                { month: 'November', value: 11 },
                { month: 'December', value: 12 },
            ],

        }
    },
    computed: {
        fields() {
            return [
                {
                    key: 'check',
                    label: '', // Set the label to an empty string to hide the heading
                },
                { key: 'id', label: this.$translate('actions') },
                { key: 'name', label: this.$translate('name') },
                { key: 'target_type', label: this.$translate('target_type') },
                { key: 'month_year', label: this.$translate('month_year') },

                { key: 'target', label: this.$translate('target') },
                // { key: 'target_total_value', label: this.$translate('target_total_value') },

                { key: 'activity_types', label: this.$translate('activity_types') },
                { key: 'roles', label: this.$translate('roles') },
                { key: 'officers', label: this.$translate('officers') },
                { key: 'agents', label: this.$translate('agents') },
                { key: 'customer_segments', label: this.$translate('customer_segments') },
                { key: 'customer_group', label: this.$translate('customer_groups') },
                { key: 'interaction_types', label: this.$translate('interaction_types') },
                // { key: 'end_time', label: this.$translate('end_time') },
                // { key: 'shift', label: this.$translate('shift') },

            ]
        },
        orderTypesArray() {
            return this.$store.getters["orderType/activityTypesByPermission"];
        },
        officers() {
            return (this.$store.state.orders.drivers || []).map((x) => ({
                id: x.id,
                name: `${x.first_name} ${x.last_name}`.trim(),
            }));
        },
        getIcons() {
            return {
                1: "fa fa-building", // Icon for Company
                2: "fa fa-user",     // Icon for Officer
            };
        },
        pageCount() {
            return Math.ceil(this.pagination.total / this.pagination.pageSize)
        },
        targets() {
            const targets = this.$store.state.targets.items_not_paginated

            return targets
        },
        roles() {
            return this.$store.state.roles.items;
        },
        pagination() {
            return this.$store.state.targets.pagination || { page: 1 }
        },

        otherActions() {
            const actions = [];

            actions.push(
                {
                    action: () => this.duplicate_target(),
                    icon: dropdownIcon2,
                    text: this.$translate("duplicate_target"),

                },
                {
                    action: () => this.view_analytics(),
                    icon: dropdownIcon2,
                    text: this.$translate("view_analytics"),

                },
                {
                    action: () => this.generate_report(),
                    icon: dropdownIcon2,
                    text: this.$translate("generate_report"),

                },
                {
                    action: () => this.bulk_delete(),
                    icon: dropdownIcon7,
                    text: this.$translate("delete"),

                },

            );



            return actions;
        },


    },

    watch: {
        targets: {
            handler: function () {
                this.tableLoading = false
            },
            deep: true,
        },
        'pagination.page': function (newPage) {
            this.changePage(newPage)
        },
        query: _.debounce(function (query) {
            this.$router.push({ query: { query } })
            this.doSearch()
        }, 200),
        filters: {
            handler: function () {

                this.fetch_year_data()
            },
            deep: true,
        },
        target_progress_filter: {
            handler: function () {

                this.fetch_target_progress()
            },
            deep: true,
        },
        value_progress_filter: {
            handler: function () {

                this.fetch_value_progress()
            },
            deep: true,
        },
        target_progress_filter_officer: {
            handler: function () {
                console.log('thiss is caleddd===================================')

                this.fetch_target_progress_officer()
            },
            deep: true,
        },
        value_progress_filter_officer: {
            handler: function () {

                this.fetch_value_progress_officer()
            },
            deep: true,
        },
        officer_filters: {
            handler: function () {

                this.fetch_year_data()
            },
            deep: true,

        },
        entityIdx: {
            handler: function () {

                this.fetch_year_data()
            },
            deep: true,
        },
        value_progress_chart_officer: {
            handler: function () {

              console.log('this is changesss==========')
            },
            deep: true,
        }
    },

    async created() {
        const today = new Date();
        const month = String(today.getMonth() + 1).padStart(2, '0');
        const year = today.getFullYear();

        this.filters.month_year = `${year}-${month}`;
        await Promise.all([
            this.$store.dispatch("orderType/fetchAll"),
            this.$store.dispatch("roles/fetchAll"),
            this.$store.dispatch("orders/fetchDriversNew"),
            this.$store.dispatch("customerAgents/fetchAll"),
            this.$store.dispatch("interactionType/fetchAll"),
            this.$store.dispatch('customerSegments/fetchAll'),
            this.$store.dispatch('customerGroups/fetchAll'),
            this.$store.dispatch('targets/fetchAll'),




        ]);
    },
    async mounted() {


        await this.fetch_year_data();
        if(this.entityIdx == 1){
            this.load_chart = true;
            this.load_activity = true;
        }
        if(this.entityIdx == 2){
            this.load_chart_officer = true;
        }
      
    },

    methods: {
        list_view() {
            this.$router.push({ name: 'Targets' });
        },
        async bulk_delete() {
            try {
                const title = this.$translate("delete_target_title");
                const message = this.$translate(`delete_target_note`);

                const result = await this.confirmMessage(title, message);
                console.log("result", result);
                if (!result) return false; //throw new Error("");

                this.tableLoading = true;
                await this.$store.dispatch("targets/bulkDelete", {
                    targets: this.selectedOrders,
                });

                this.doToast(
                    this.$translate("success"),
                    this.$translate("bulk_target_delete"),
                    "success"
                );

                await this.doSearch();
            } catch (err) {
                console.error(err);
                this.doToast(
                    this.$translate("error"),
                    this.$translate("bulk_target_delete_error"),
                    "danger"
                );
            } finally {
                this.clearSelected();
                this.doSearch(true);
                this.tableLoading = false;
            }
        },
        generate_report() {

        },
        view_analytics() {

        },
        async duplicate_target() {
            try {


                this.tableLoading = true;
                await this.$store.dispatch("targets/duplicate", {
                    targets: this.selectedOrders,
                });

                this.doToast(
                    this.$translate("success"),
                    this.$translate("bulk_target_duplicate"),
                    "success"
                );

                await this.doSearch();
            } catch (err) {
                console.error(err);
                this.doToast(
                    this.$translate("error"),
                    this.$translate("bulk_target_duplicate_error"),
                    "danger"
                );
            } finally {
                this.clearSelected();
                this.doSearch(true);
                this.tableLoading = false;
            }

        },
        clearSelected() {
            this.$refs.selectableTable && this.$refs.selectableTable.clearSelected();
        },
        onRowSelected(items) {
            this.selectedOrders = items;
        },
        toggleRow(index, rowSelected) {
            // Rows are indexed from 0, so the third row is index 2
            if (rowSelected) this.$refs.selectableTable.unselectRow(index);
            else this.$refs.selectableTable.selectRow(index);
        },

        toggleAllRow() {
            if (this.targets.length === this.selectedOrders.length)
                this.$refs.selectableTable.clearSelected();
            else this.$refs.selectableTable.selectAllRows();
        },

        changePage(page) {
            this.$router.push({ query: { page } })
            this.doSearch()
        },
        resetFilters() {
            this.setDefaultDateRange();
            this.doSearch()
        },
        async doSearch() {
            let type = "";
            if (this.filters.type && this.filters.type.length > 0 && Array.isArray(this.filters.type)) {
                type = this.filters.type.map((i) => i.id).join(",");
            }

            let role = "";
            if (this.filters.role && this.filters.role.length > 0 && Array.isArray(this.filters.role)) {
                role = this.filters.role.map((i) => i.id).join(",");
            }

            let officer = "";
            if (this.filters.officer && this.filters.officer.length > 0 && Array.isArray(this.filters.officer)) {
                officer = this.filters.officer.map((i) => i.id).join(",");
            }

            let agent = "";
            if (this.filters.agent && this.filters.agent.length > 0 && Array.isArray(this.filters.agent)) {
                agent = this.filters.agent.map((i) => i.id).join(",");
            }
            let customer_segment = "";
            if (this.filters.customer_segment && this.filters.customer_segment.length > 0 && Array.isArray(this.filters.customer_segment)) {
                customer_segment = this.filters.customer_segment.map((i) => i.id).join(",");
            }

            let interaction_type = "";
            if (this.filters.interaction_type && this.filters.interaction_type.length > 0 && Array.isArray(this.filters.interaction_type)) {
                interaction_type = this.filters.interaction_type.map((i) => i.id).join(",");
            }

            let customer_group = "";
            if (this.filters.customer_group && this.filters.customer_group.length > 0 && Array.isArray(this.filters.customer_group)) {
                customer_group = this.filters.customer_group.map((i) => i.id).join(",");
            }


            try {
                this.$store.commit('targets/updateFilter', {
                    query: this.query,
                    filters: { ...this.filters, type: type, role: role, officer: officer, agent: agent, customer_segment: customer_segment, interaction_type: interaction_type, customer_group: customer_group }
                });
                this.tableLoading = true
                const {
                    pagination: { page },
                    query,
                    filters
                } = this
                await this.$store.dispatch('targets/fetch', {
                    query,
                    page,
                    filters: { ...filters, type: type, role: role, officer: officer, agent: agent, customer_segment: customer_segment, interaction_type: interaction_type, customer_group: customer_group }
                })
            } catch (error) {
                console.error('loading error', error)
            }
        },
        view(index) {
            const path = `${this.$route.path}/${index}`
            console.log('path---', path);
            this.$router.push({ path })
        },

        truncate(text, length) {
            return _.truncate(text, { length: length })
        },
        addBudget() {
            const id = 0
            this.$router.push({ params: { id }, name: 'viewTarget' })
        },

        openModel() {

            this.importModal = true;
        },
        async export_roster() {

            this.tableLoading = true
            let filter_target = this.$store.state.targets.filter;
            let query_target = this.$store.state.targets.query;

            console.log('query-filter', filter_target);
            await this.$store.dispatch('targets/exportExcelCSV', {

                query_target,
                filter_target
            })
            this.tableLoading = false
        },
        setDefaultDateRange() {
            const currentDate = new Date();
            const currentDay = currentDate.getDay();
            const diffToSunday = currentDay === 0 ? 0 : 7 - currentDay;

            // Calculate the start date (two Sundays ago)
            const startDate = new Date(currentDate);
            startDate.setDate(currentDate.getDate() - currentDay + diffToSunday - 7);

            // Calculate the end date (next Saturday)
            const endDate = new Date(startDate);
            endDate.setDate(startDate.getDate() + 13);

            // Format dates to YYYY-MM-DD for the date input fields
            const formatDate = (date) => {
                return date.toISOString().split('T')[0];
            };

            this.filters.start_date = formatDate(startDate);
            this.filters.end_date = formatDate(endDate);
            const defaultStartTime = '10:00'; // Default start time
            const defaultEndTime = '19:00'; // Default end time
            this.filters.filter_date = formatDate(currentDate); // Set current date as the filter date
            this.filters.start_time = defaultStartTime;
            this.filters.end_time = defaultEndTime;
        },

        showModal(activityTypes) {
            this.activityTypes = activityTypes; // Set the activity types to display in the modal
            this.isModalVisible = true; // Show the modal
        },
        resetModal() {
            this.activityTypes = []; // Reset activity types when modal is closed
        },
        formatMonthYear(monthYearString) {
            const [year, month] = monthYearString.split('-'); // Split the string into year and month
            const monthNames = [
                'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
                'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'
            ]; // Array of month names
            const monthIndex = parseInt(month) - 1; // Convert month to index (0-11)
            return `${monthNames[monthIndex]}-${year}`; // Return formatted string
        },

        changeEntityIdx(value) {
            this.entityIdx = value;
            // Update selector position and width dynamically based on the selected item
            this.updateSelector(value);
        },
        updateSelector(value) {
            // Logic for updating `divWidth` and `divLeft`
            // This is just a placeholder for visual effects
            if (value === 1) {
                this.divWidth = "160px";
                this.divLeft = "20px";
            } else if (value === 2) {
                this.divWidth = "160px";
                this.divLeft = "188px";
            }
        },
        generateYearOptions() {
            const currentYear = new Date().getFullYear();
            const startYear = 1900; // You can change the start year
            const years = [];

            for (let year = currentYear; year >= startYear; year--) {
                years.push({ year });
            }

            return years;
        },
        randomValue() {
            this.value = Math.random() * this.max
        },
        async fetch_year_data() {
            this.tableLoading = true;
            console.log('this is entityIdx', this.entityIdx);
            console.log('this is filter', this.filters);
            if (this.entityIdx == 1) {
                //get target progress data for month year 
                await this.$store.dispatch('targets/getTargetProgress', {
                    filter: this.filters
                });
                this.target_progress = this.$store.state.targets.target_progress;
                await this.$store.dispatch('targets/getValueProgress', {
                    filter: this.filters
                });
                await this.$store.dispatch("targets/fetchActivity", {
                    filter: this.filters
                })
                this.activities = this.$store.state.targets.activities;
                this.value_progress = this.$store.state.targets.value_progress;
                this.value_progress_chart.total_completed_amount = this.value_progress.total_completed_amount;
                this.value_progress_chart.total_target_value = this.value_progress.total_target_amount;
            }
            if (this.entityIdx == 2) {
                //get target progress data for month year 
                await this.$store.dispatch('targets/getTargetProgressOfficer', {
                    filter: { ...this.officer_filters, ...this.target_progress_filter_officer }
                });
                this.target_progress_officer = this.$store.state.targets.target_progress_officer;

                console.log('this is values=============', this.target_progress_officer)
                await this.$store.dispatch('targets/getValueProgressOfficer', {
                    filter: { ...this.officer_filters, ...this.value_progress_filter_officer }
                });
                this.value_progress_officer = this.$store.state.targets.value_progress_officer;
                this.value_progress_chart_officer.total_completed_amount = this.value_progress_officer.total_completed_amount;
                this.value_progress_chart_officer.total_target_value = this.value_progress_officer.total_target_amount;
                this.load_chart_officer = true;
            }

            this.tableLoading = false;

        },
        async fetch_target_progress() {

            this.tableLoading = true;
            console.log('this is entityIdx', this.entityIdx);
            console.log('this is filter', this.filters);
            if (this.entityIdx == 1) {
                //get target progress data for month year 
                await this.$store.dispatch('targets/getTargetProgress', {
                    filter: { ...this.filters, ...this.target_progress_filter }
                });
                this.target_progress = this.$store.state.targets.target_progress;
                // await this.$store.dispatch('targets/getValueProgress', {
                //     filter: this.filters
                // });
                // this.value_progress = this.$store.state.targets.value_progress;
            }

            this.tableLoading = false;

        },
        async fetch_value_progress() {

            this.tableLoading = true;
            console.log('this is entityIdx', this.entityIdx);
            console.log('this is filter', this.filters);

            if (this.entityIdx === 1) { // Use strict equality for comparison
                // Get target progress data for month year 
                await this.$store.dispatch('targets/getValueProgress', {
                    filter: { ...this.filters, ...this.value_progress_filter }
                });

                // Ensure value_progress is available in the store before accessing
                this.value_progress = this.$store.state.targets.value_progress;

                // Assign values for chart data
                this.value_progress_chart.total_completed_amount = this.value_progress.total_completed_amount;
                this.value_progress_chart.total_target_value = this.value_progress.total_target_amount;
            }

            this.tableLoading = false;


        },
        async fetch_target_progress_officer() {

            this.tableLoading = true;
            console.log('this is entityIdx', this.entityIdx);
            console.log('this is filter', this.officer_filters);
            if (this.entityIdx == 2) {
                await this.$store.dispatch('targets/getTargetProgressOfficer', {
                    filter: { ...this.officer_filters, ...this.target_progress_filter_officer }
                });
                this.target_progress_officer = this.$store.state.targets.target_progress_officer;

                console.log('this is values=============', this.target_progress_officer)
             
            }

            this.tableLoading = false;

        },
        async fetch_value_progress_officer() {

            this.tableLoading = true;
            console.log('this is entityIdx', this.entityIdx);
            console.log('this is filter', this.officer_filters);

            if (this.entityIdx === 2) { 
                await this.$store.dispatch('targets/getValueProgressOfficer', {
                    filter: { ...this.officer_filters, ...this.value_progress_filter_officer }
                });
                this.value_progress_officer = this.$store.state.targets.value_progress_officer;
                this.value_progress_chart_officer.total_completed_amount = this.value_progress_officer.total_completed_amount;
                this.value_progress_chart_officer.total_target_value = this.value_progress_officer.total_target_amount;
               
            }

            this.tableLoading = false;


        },
        formatCurrency(value) {
            // Format the number as currency with commas
            return `$${value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}`;
        },

        calculateTotals() {
            const targets = this.year_data; // Get targets from year_data

            // Initialize totals
            let total_activity_target = 0;
            let total_value_target = 0;

            // Calculate totals
            // Calculate totals
            targets.forEach(target => {
                total_activity_target += parseInt(target.target_no_of_activity || 0); // Aggregate activity targets
                total_value_target += parseFloat(target.target_total_value || 0);      // Aggregate total values
            });

            // Format totals to 2 decimal points

            total_value_target = parseFloat(total_value_target).toFixed(2);

            // Return the calculated totals
            return {
                total_activity_target,
                total_value_target,
            };
        },
        calculateTotalsOfficer() {
            const targets = this.year_data_officer; // Get targets from year_data

            // Initialize totals
            let total_activity_target = 0;
            let total_value_target = 0;

            // Calculate totals
            // Calculate totals
            targets.forEach(target => {
                total_activity_target += parseInt(target.target_no_of_activity || 0); // Aggregate activity targets
                total_value_target += parseFloat(target.target_total_value || 0);      // Aggregate total values
            });

            // Format totals to 2 decimal points

            total_value_target = parseFloat(total_value_target).toFixed(2);

            // Return the calculated totals
            return {
                total_activity_target,
                total_value_target,
            };
        },
    },

}
</script>
<style scoped>
.role-badge-container {
    display: flex;
    flex-wrap: wrap;
    /* Allow wrapping to the next line */
    gap: 8px;
    /* Adjust space between the badges */
}

.role-badge {
    flex-basis: calc(25% - 8px);
    /* Each badge takes 25% width, minus the gap */
    text-align: center;
    /* Center align text within each badge */
    white-space: nowrap;
    /* Prevent text from wrapping inside badge */
}

.square-card {

    border: 1px solid #ddd;
    border-radius: 10px;
    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
}

.progress {
    border-radius: 10px;
    border: 1px solid;

}

.custom-progress {
    height: 25px !important;
}

.custom-progress-inside {
    height: 15px !important;
}
</style>